import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSEO } from "@/hooks/useSEO";
import { BRAND_HANDLE, BRAND_PERSON_NAME, BRAND_SITE_URL } from "@/lib/brandConfig";
import { BaseTemplate } from "@/components/templates/BaseTemplate";

/**
 * Cartagena — Public SEO landing page using BaseTemplate.
 * /cartagena and /en/cartagena. Excellent rich template + admin controls (heroCta, gallery, mux video CTA with Stripe for CO).
 * Equivalent capability to Argentina region pages.
 */
const Cartagena = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const isEn = location.pathname.startsWith("/en/") || location.pathname.startsWith("/en");

  useEffect(() => {
    if (isEn && i18n.language?.split("-")[0] !== "en") {
      void i18n.changeLanguage("en");
    }
  }, [isEn, i18n]);

  const locale = isEn ? "en_US" : "es_CO";
  const title = isEn
    ? `${BRAND_PERSON_NAME} | Cartagena Colombia — Content Creator | Exclusive Caribbean Access`
    : `${BRAND_PERSON_NAME} | Cartagena Colombia — Creadora | Acceso Exclusivo Caribe`;
  const description = isEn
    ? `Exclusive lifestyle, fitness & beauty for Cartagena & Colombian Caribbean from ${BRAND_PERSON_NAME}. Private community — Stripe checkout.`
    : `Contenido exclusivo lifestyle, fitness y belleza para Cartagena y el Caribe colombiano de ${BRAND_PERSON_NAME}. Comunidad privada — checkout Stripe.`;
  const keywords = isEn
    ? `${BRAND_PERSON_NAME}, cartagena, colombia caribe, content creator cartagena, exclusive membership stripe, fitness cartagena`
    : `${BRAND_PERSON_NAME}, cartagena, colombia caribe, creadora cartagena, membresia exclusiva stripe, fitness cartagena`;

  useSEO({
    title,
    description,
    keywords,
    ogImage: `${BRAND_SITE_URL}/og.png`,
    ogTitle: title,
    ogDescription: description,
    canonical: `${BRAND_SITE_URL}${location.pathname.replace(/\/$/, "") || "/cartagena"}`,
    author: BRAND_PERSON_NAME,
    locale,
    alternateLocale: isEn ? "es_CO" : "en_US",
    type: "website",
    publishedTime: "2025-01-01T00:00:00.000Z",
    modifiedTime: new Date().toISOString(),
  });

  const heroTitle = isEn ? `${BRAND_PERSON_NAME} in Cartagena` : `${BRAND_PERSON_NAME} Cartagena`;
  const heroDescription = isEn
    ? "Private premium content for Cartagena. Stripe-powered membership."
    : "Contenido premium privado para Cartagena. Membresía con Stripe.";

  return (
    <BaseTemplate
      heroTitle={heroTitle}
      heroDescription={heroDescription}
      showSobreMi={false}
      showPortfolioNavLink
      showGalleryNavLink
      showContactNavLink
      showGallerySection
      showTallySection
    />
  );
};

export default Cartagena;
